var _circle, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableUnavilable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1433,
    cy: 24.9445,
    r: 14.8605,
    stroke: "#BEBEBE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.9628,
    y: 1.5,
    width: 14.3605,
    height: 5.32491,
    rx: 2.66246,
    stroke: "#BEBEBE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0077,
    y: 11.1152,
    width: 14.3605,
    height: 5.32491,
    rx: 2.66246,
    transform: "rotate(72.3781 45.0077 11.1152)",
    stroke: "#BEBEBE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.6715,
    y: 39.3011,
    width: 14.3605,
    height: 5.32491,
    rx: 2.66246,
    transform: "rotate(143.156 44.6715 39.3011)",
    stroke: "#BEBEBE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.325191,
    y: -0.627894,
    width: 14.3605,
    height: 5.32491,
    rx: 2.66246,
    transform: "matrix(0.302703 -0.953085 -0.953085 -0.302703 5.20301 26.0752)",
    stroke: "#BEBEBE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.699948,
    y: 0.100365,
    width: 14.3605,
    height: 5.32491,
    rx: 2.66246,
    transform: "matrix(-0.800313 -0.599582 -0.599582 0.800313 19.4382 43.0677)",
    stroke: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableUnavilable);
export default __webpack_public_path__ + "static/media/tableUnavilable.e8dfac2da0fa142a8c265adc6303f703.svg";
export { ForwardRef as ReactComponent };